import { useState, useContext, useEffect } from "react";
import { ref as dbRef, set, get } from "firebase/database";
import { rtdb } from "../../firebase.config";
import { UserContext } from "../../context/UserContext";

const useSaveBankDetails = () => {
  const { user } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [bankDetails, setBankDetails] = useState(null);
  const [error, setError] = useState(null);

  const fetchBankDetails = async () => {
    if (!user?.uid) return;

    try {
      const ref = dbRef(rtdb, `bankAccounts/${user.uid}`);
      const snapshot = await get(ref);
      if (snapshot.exists()) {
        setBankDetails(snapshot.val());
      }
    } catch (err) {
      console.error("Failed to fetch bank details:", err);
    }
  };

  const saveBankDetails = async (details) => {
    setLoading(true);
    setError(null);
    try {
      const ref = dbRef(rtdb, `bankAccounts/${user.uid}`);
      await set(ref, details);
      setBankDetails(details);
      setLoading(false);
      return { success: true };
    } catch (err) {
      console.error("Failed to save bank details:", err);
      setError("Error saving bank details");
      setLoading(false);
      return { success: false, error: err };
    }
  };

  useEffect(() => {
    fetchBankDetails();
  }, [user?.uid]);

  return { bankDetails, saveBankDetails, loading, error };
};

export default useSaveBankDetails;
